<template>
<vs-radio :vs-name="constantValue"
          :vs-value="constantValue"
          :value="dynamicValue"
          :color="focusColor"
          :tabindex="tabindex"
          class="focus:border-focus-error focus:border hover:border-focus-error"
          @change="$emit('selected')">
  <div class="flex items-center ml-1">
    <span>{{ label }}</span>
    <vx-tooltip v-if="tooltipText" :text="tooltipText" position="bottom">
      <vs-icon :icon="tooltipIcon" size="1.3rem" class="ml-1 text-gray cursor-default"></vs-icon>
    </vx-tooltip>
  </div>
</vs-radio>
</template>

<script>
import tailwind from '../../../tailwind.config'

export default {
  name: 'RadioButton',
  props: {
    constantValue: {
      type: String,
      required: true
    },
    dynamicValue: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    tabindex: {
      type: Number,
      required: true
    },
    tooltipText: {
      type: String,
      default: ''
    },
    tooltipIcon: {
      type: String,
      default: ''
    }
  },
  computed: {
    focusColor() {
      return tailwind.theme.colors.focus
    }
  }
}
</script>
